import React from 'react';
import Grid from '@mui/material/Grid2';
// import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { useState } from 'react';
// import { styled } from '@mui/system';
import PrivacyPolicyModal from './PrivacyPolicyModal';
import sfondoSmall from './sfondo_small.png';
import divider1 from './divider1.png';
import divider2 from './divider2.png';
import divider3 from './divider3.png';


const targetMail = "info@morkthulhu.com";
// const CustomTextField = styled(TextField)({
//     '& input': {
//         color: 'white',       // Colore del testo
//     },
//     '& label': {
//         color: 'white',       // Colore dell'etichetta
//     },
//     '& .MuiOutlinedInput-root': {
//         '& fieldset': {
//             borderColor: '#F7D97F', // Colore del bordo
//         },
//         '&:hover fieldset': {
//             borderColor: '#F7D97F', // Colore del bordo al passaggio del mouse
//         },
//         '&.Mui-focused fieldset': {
//             borderColor: '#F7D97F', // Colore del bordo quando in focus
//         },
//     },
//     '& .MuiInputLabel-root': {
//         '&.Mui-focused': {
//             color: 'white',
//         },
//     },
// });

const InterestForm = () => {
    const [email, setEmail] = useState('');
    const [open, setOpen] = useState(false);

    const handleSubmit = (event) => {
        event.preventDefault();
        if (!validateEmail(email)) {
            alert('Per favore, inserisci un indirizzo email valido.');
            return;
        }
        const link = "mailto:" + targetMail + "?subject=" + encodeURIComponent("Avvisami quando pubblicherai Morkthulhu!") + "&body=" + encodeURIComponent("Ti lascio la mia mail, avvisami quando Morkthulhu sarà disponibile: " + email);
        window.open(link, "_blank");
    }

    const handleOpen = () => {
        setOpen(true);
    }

    const validateEmail = (email) => {
        const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return re.test(String(email).toLowerCase());
    };

    const handleClose = () => {
        setOpen(false);
    }

    const navigateAppSchede = () => {
        window.location.href = "https://www.morkthulhu.com/qs-6311";
    }

    // const navigateQRCodeSito = () => {
    //     window.location.href = "https://www.morkthulhu.com/qrsito.png";
    // }

    const navigateScaricaQuickstart = () => {
        window.location.href = "https://www.morkthulhu.com/quickstart";
    }

    // const navigateInstagram = () => {
    //     window.location.href = "https://www.instagram.com/morkthulhu/";
    // }

    const navigateAppMaster = () => {
        window.location.href = "https://www.morkthulhu.com/qs-0278";
    }

    return (
        <form onSubmit={handleSubmit}>
            <Grid container spacing={2} alignItems="center" display="flex" justifyContent="center">
                <Grid item size={12}>&nbsp;</Grid>
                <Grid item size={12}>
                    <img src={sfondoSmall} alt="Morkthulhu" style={{ width: "100%", height: "auto" }} />
                </Grid>
                <Grid item size={12}>
                    <Typography variant="h4" align="left">
                        Grazie per il tuo interesse!
                    </Typography>
                </Grid>
                <Grid item size={12}>
                    <Typography variant="body1" align="justify">
                        Il mondo oscuro e tentacolare di Morkthulhu si è già aperto… e continua a crescere. Vuoi unirti al culto?
                    </Typography>
                </Grid>
                <Grid item size={12}>
                    <Typography variant="body1" align="justify">
                        Quickstart gratuito per immergerti subito nell’atmosfera. Lascia la tua email e inizia a giocare.
                    </Typography>
                </Grid>
                <Grid item size={12}>
                    <Typography variant="body1" align="justify">
                        Ti terremo aggiornato sul Kickstarter e sulle novità più importanti. Nessun impegno, solo il piacere di restare in contatto.
                    </Typography>
                </Grid>
                <Grid item size={12} display="flex" justifyContent="center">
                    <Button
                        variant="text"
                        color="white"
                        onClick={navigateScaricaQuickstart}
                        style={{
                            fontSize: '1.5rem',
                            padding: '16px 32px',
                            minWidth: '250px'
                        }}
                    >
                        VAI AL MINISITO DEL QUICKSTART
                    </Button>
                </Grid>
                <Grid item size={12}>
                    <img src={divider2} alt="Morkthulhu" style={{ width: "100%", height: "auto" }} />
                </Grid>
                <Grid item size={12} display="flex" justifyContent="center">
                    <Typography variant="body1" align="center" style={{
                        fontSize: '1.5rem',
                        padding: '16px 32px',
                        minWidth: '250px'
                    }}>
                        Non bastava infestare i tavoli da gioco… ora ci trovate pure nei podcast.<br />
                    </Typography>
                </Grid>
                <div style={{ position: "relative", width: "70%", overflow: "hidden" }}>
                    <iframe title='podcast avalonair' data-testid="embed-iframe" style={{ borderRadius: 12 }} src="https://open.spotify.com/embed/episode/7244V37vTZvEWDb1UhgrWT?utm_source=generator" width="100%" height="352" frameBorder="0" allowfullscreen="" allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture" loading="lazy"></iframe>
                </div>
                <Grid item size={12}>
                    <img src={divider2} alt="Morkthulhu" style={{ width: "100%", height: "auto" }} />
                </Grid>
                <Grid item size={12} display="flex" justifyContent="center">
                    <Typography variant="body1" align="center" style={{
                        fontSize: '1.5rem',
                        padding: '16px 32px',
                        minWidth: '250px'
                    }}>
                        Il caos si ascolta e si guarda: ecco i video che ci hanno evocato.<br />
                        FUORI I POP-CORN!
                    </Typography>
                </Grid>
                <div style={{ position: "relative", width: "70%", paddingBottom: "39.375%", height: 0, margin: "0 auto", overflow: "hidden" }}>
                    <iframe
                        src="https://www.youtube.com/embed/1yn1yvBbLpY?si=dAU4_ghak8PSumli"
                        title="YouTube video player"
                        frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        referrerpolicy="strict-origin-when-cross-origin"
                        allowfullscreen
                        style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%" }}>
                    </iframe>
                </div>
                <Grid item size={12}>&nbsp;</Grid>
                <div style={{ position: "relative", width: "70%", paddingBottom: "39.375%", height: 0, margin: "0 auto", overflow: "hidden" }}>
                    <iframe
                        src="https://www.youtube.com/embed/oukHBE6Eysc?si=3X6dV-QdxABMVBlu"
                        title="YouTube video player"
                        frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        referrerpolicy="strict-origin-when-cross-origin"
                        allowfullscreen
                        style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%" }}>
                    </iframe>
                </div>
                <Grid item size={12}>&nbsp;</Grid>
                <div style={{ position: "relative", width: "70%", paddingBottom: "39.375%", height: 0, margin: "0 auto", overflow: "hidden" }}>
                    <iframe
                        src="https://www.youtube.com/embed/xwMSiAYiqK8?si=Dz8Uc90uCZ2nrnMM"
                        title="YouTube video player"
                        frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        referrerpolicy="strict-origin-when-cross-origin"
                        allowfullscreen
                        style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%" }}>
                    </iframe>
                </div>
                <Grid item size={12}>&nbsp;</Grid>

                <Grid item size={12}>
                    <img src={divider3} alt="Morkthulhu" style={{ width: "100%", height: "auto" }} />
                </Grid>
                <Grid item size={12}>&nbsp;</Grid>
                <Grid item size={4}>
                    <Button onClick={navigateAppMaster} variant="text" fullWidth style={{ color: '#F7D97F' }}>
                        App del Master
                    </Button>
                </Grid>
                <Grid item size={4}>
                    <Button onClick={navigateAppSchede} variant="text" fullWidth style={{ color: '#F7D97F' }} >
                        App del Giocatore
                    </Button>
                </Grid>
                <Grid item size={4}>
                    <Button onClick={handleOpen} variant="text" fullWidth style={{ color: '#F7D97F' }}>
                        Privacy Policy
                    </Button>
                </Grid>
                <Grid item size={12}>&nbsp;</Grid>
                <Grid item size={12}>
                    <img src={divider1} alt="Morkthulhu" style={{ width: "100%", height: "auto" }} />
                </Grid>
                <Grid item size={12}>
                    <div style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        width: '100%',
                        height: 'auto',
                        filter: 'invert(100%)'
                    }}>
                        <img src={`${process.env.PUBLIC_URL}/CompWith_MORKBORG_horiz.svg`} alt="Compatibile con MÖRK BORG" style={{ maxWidth: '70%', height: 'auto' }} />
                    </div>
                </Grid>
                <Grid item size={12}>
                    <Typography variant="body2" align="justify" sx={{ fontStyle: 'italic' }}>
                        <strong>Morkthulhu</strong> è una produzione indipendente dei suoi autori e non è affiliata,
                        sponsorizzata o approvata da Ockult Örtmästare Games o Stockholm Kartell.
                        È pubblicata sotto la <strong>MÖRK BORG Third Party License</strong>.
                    </Typography>
                </Grid>
                <Grid item size={12}>
                    <Typography variant="body2" align="justify" sx={{ fontStyle: 'italic' }}>
                        <strong>MÖRK BORG</strong> è © Ockult Örtmästare Games e Stockholm Kartell.
                    </Typography>
                </Grid>
                <Grid item size={12}>&nbsp;</Grid>
            </Grid>
            <PrivacyPolicyModal open={open} onClose={handleClose} />
        </form >
    );
};

export default InterestForm;